import { render, staticRenderFns } from "./DictCascader.vue?vue&type=template&id=406969cc&scoped=true&"
import script from "./DictCascader.vue?vue&type=script&lang=js&"
export * from "./DictCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406969cc",
  null
  
)

export default component.exports